/**
 * Handy, 14 Tage: die Zellen sind zu schmal für einzelne Balken. Ein Tipp auf die Zeile öffnet ein
 * Blatt mit ihren Belegungen im Ausschnitt (alle Details) und den freien Tagen dazwischen.
 */
import type { ParkingOccupancySpotRow } from '@/shared/api';
import { BottomSheet } from '@/shared/components';
import { ParkingReservationDetails } from './ParkingReservationDetails';
import { freeRanges } from './parkingCalendarHelpers';

const short = (iso: string) => `${iso.slice(8, 10)}.${iso.slice(5, 7)}.`;

export function ParkingSpotOverview({
  spot,
  dates,
  onOpenChange,
}: {
  spot: ParkingOccupancySpotRow | null;
  dates: string[];
  onOpenChange: (open: boolean) => void;
}) {
  const visible = spot
    ? spot.reservations.filter(
        (entry) => entry.endDate > (dates[0] ?? '') && entry.startDate <= (dates.at(-1) ?? ''),
      )
    : [];
  const free = spot ? freeRanges(spot.reservations, dates) : [];
  return (
    <BottomSheet
      open={spot !== null}
      onOpenChange={onOpenChange}
      title={spot?.label ?? ''}
      description={spot && !spot.isActive ? 'Stillgelegt – nimmt nichts Neues auf' : undefined}
    >
      <div className="flex flex-col gap-3 py-1">
        <section className="bg-paper rounded-lg p-3.5">
          <h3 className="mb-1 text-[13px] font-bold">Freie Tage</h3>
          <p className="text-ink-soft text-[13px]">
            {free.length
              ? free
                  .map(([from, to]) =>
                    from === to ? short(from) : `${short(from)} – ${short(to)}`,
                  )
                  .join(', ')
              : 'Im Ausschnitt kein freier Tag.'}
          </p>
        </section>
        {visible.length === 0 ? (
          <p className="text-ink-soft text-[13px]">Im Ausschnitt keine Belegung.</p>
        ) : (
          visible.map((entry) => (
            <section key={entry.reservationId} className="border-hairline rounded-lg border p-3.5">
              <ParkingReservationDetails entry={entry} />
            </section>
          ))
        )}
      </div>
    </BottomSheet>
  );
}
